import api from '../api'

class CartService {
	static save(data) {
		return api({
			method: 'post',
			url: 'cart',
			data: data,
		})
	}

	static addProductCart(data) {
		return api({
			method: 'post',
			url: `add-cart`,
			data: data,
		})
  }

  static verifiedStock(product_id, variant_id, quantity) {
    return api({
      url: 'verified-stock-product',
      params: { product_id, variant_id, quantity }
    })
  }

	static set(cart) {
		return api({
			method: 'post',
			url: 'set-cart',
			data: cart
		})
	}

	static updateQuantity(data) {
		return api({
			method: 'post',
			url: 'cart-update-quantity',
			data: data,
		})
	}

	static removeProductCart(data) {
		return api({
			method: 'delete',
			url: 'remove-cart',
			data: data,
		})
	}

	static cleanCart() {
		return api({
			method: 'delete',
			url: 'clean-cart',
		})
	}

	static getTotalCart(data) {
		return api({
			method: 'post',
			data: data,
			url: 'public/cart-total',
		})
	}

	static getStatusTransactionById(transaction_id) {
		return api({
			method: 'get',
			params: {
				transaction_id,
			},
			url: 'get-status-transaction-by-id',
		})
	}

	static verifyCart(data) {
		return api({
			method: 'post',
			url: 'verify-cart',
			data: data,
		})
	}
}

export default CartService
